import _ from 'lodash'
import vacancyApplicationApi from '@/api/vacancy-application'
import store from '@/store'
import form from './form'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  statusId: 0,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    searchQuery: '',
    statusId: 0,
    sortBy: '',
    sortDesc: false
  }
}

const getters = {
}

const actions = {
  fetchList({ commit }) {
    state.loading = true;
    vacancyApplicationApi.getAll({...state.filters})
      .then(( {data} ) => commit('SET_LIST', data))
  },
}

const mutations = {
  SET_LIST(state, {items, metadata}) {
    state.list = items;
    state.totalCount = metadata.totalItemCount;
    state.loading = false;
  },
  CLEAR_ERRORS(state) {
    state.errors = [];
  },
  ...generateFormHandlerMutations(state)
}

const modules = {
  form
}

const watchers = [
  [state => state.vacancyApplication.filters, _.debounce(async () => await store.dispatch('vacancyApplication/fetchList'), 0), { immediate: false, deep: true }]
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers
}
